import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PostOcrAccountsRequestModel, PostOcrAccountsResponseModel } from "@/features/accounts/ocr/services/post-accounts-model";

export class PostOcrAccountsApi {
  /**
   * OCR口座登録API
   */
  public postOcrAccounts = async (
    param: PostOcrAccountsRequestModel
  ): Promise<PostOcrAccountsResponseModel> => {
    const path = `/api/ocraccounts`;
    const res = await ApiClient.instance.post<PostOcrAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
